import { globalToastService } from '@repo/atomic-components';
import { SaveUserToolkitToolRequest, useSaveUserToolkitToolMutation } from '@/api/toolkit';
import { UserRoleType } from '@/api';
import { useAppSelector, selectUserAboutData } from '@/store';
import type { ToolkitPromptFormSubmitHandler } from '@/ui/components/ToolkitPromptFormModal';

export interface UseSavePromptToToolkitOptions {
  onSuccess?: () => void;
}

export interface UseSavePromptToToolkitResult {
  handleSubmit: ToolkitPromptFormSubmitHandler;
  isLoading: boolean;
}

export const useSavePromptToToolkit = ({
  onSuccess,
}: UseSavePromptToToolkitOptions = {}): UseSavePromptToToolkitResult => {
  const [saveUserToolkitTool, { isLoading }] = useSaveUserToolkitToolMutation();
  const userAboutData = useAppSelector(selectUserAboutData);
  const isGlobalAdmin = userAboutData?.role === UserRoleType.GLOBAL_ADMIN;

  const handleSubmit: ToolkitPromptFormSubmitHandler = async (values) => {
    try {
      const payload: SaveUserToolkitToolRequest = {
        toolName: values.toolName.trim(),
        toolDescription: values.toolDescription.trim(),
        prompt: values.prompt.trim(),
      };
      if (isGlobalAdmin) {
        payload.globalAdminAsUser = userAboutData?.userId;
      }

      await saveUserToolkitTool(payload).unwrap();

      globalToastService.show({
        closable: true,
        severity: 'success',
        summary: 'Prompt successfully saved to your toolkit',
        life: 6000,
      });

      onSuccess?.();
    } catch {
      globalToastService.show({
        closable: true,
        severity: 'error',
        summary: 'Prompt failed to save to toolkit. Please try again.',
        life: 6000,
      });
    }
  };

  return { handleSubmit, isLoading };
};
